import { render, staticRenderFns } from "./VueDropZone.vue?vue&type=template&id=3795a25c&scoped=true"
import script from "./VueDropZone.vue?vue&type=script&lang=js"
export * from "./VueDropZone.vue?vue&type=script&lang=js"
import style0 from "./VueDropZone.vue?vue&type=style&index=0&id=3795a25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795a25c",
  null
  
)

export default component.exports